import React from "react";

import { isNativeApplication, nativeApplication } from "../../services";
import { cva } from "../../styled-system/css";

export const linkStyles = cva({
  base: {
    cursor: "pointer",
    fontWeight: "400",
    textDecoration: "underline",
  },
  defaultVariants: {
    color: "muted-foreground",
    fontSize: "12px",
  },
  variants: {
    color: {
      "muted-foreground": { color: "muted-foreground" },
      "card-foreground": { color: "card-foreground" },
    },
    fontSize: {
      "12px": { fontSize: "12px" },
      "14px": { fontSize: "14px" },
    },
  },
});

export type ExternalLinkProperties = React.ComponentProps<"a">;
export function ExternalLink({
  href,
  onClick,
  rel,
  target,
  ...properties
}: ExternalLinkProperties) {
  return (
    <a
      {...properties}
      href={href}
      onClick={function (event) {
        onClick?.(event);

        if (isNativeApplication() && href && !event.isDefaultPrevented()) {
          event.preventDefault();
          nativeApplication.open(href);
        }
      }}
      rel={rel ?? "noopener"} // タブナビング攻撃を防ぐ。
      target={target ?? "_blank"} // 新しいタブで開く。
    />
  );
}
